import { render, staticRenderFns } from "./ConsentDialog.vue?vue&type=template&id=290afbc8&scoped=true"
import script from "./ConsentDialog.vue?vue&type=script&lang=ts"
export * from "./ConsentDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConsentDialog.vue?vue&type=style&index=0&id=290afbc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290afbc8",
  null
  
)

export default component.exports